
import { Link } from '../base/Link';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className="bg-gray-900 text-white">
      <div className="px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {/* 产品模块 */}
          <div>
            <h4 className="font-semibold text-lg mb-4">
              <Link to="/#products" className="hover:text-blue-400 transition-colors">{t('footer.productsTitle')}</Link>
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/damaya" className="text-gray-300 hover:text-white transition-colors">{t('nav.damaya')}</Link>
              </li>
              <li>
                <Link to="/video-redaction" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.videoRedaction')}
                </Link>
              </li>
              <li>
                <Link to="/image-redaction" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.imageRedaction')}
                </Link>
              </li>
              <li>
                <Link to="/text-redaction" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.textRedaction')}
                </Link>
              </li>
              <li>
                <Link to="/file-redaction" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.fileRedaction')}
                </Link>
              </li>
            </ul>
          </div>

          {/* 支持中心 */}
          <div>
            <h4 className="font-semibold text-lg mb-4">
              <Link to="/pricing#api-pilot" className="hover:text-blue-400 transition-colors">{t('footer.supportTitle')}</Link>
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/examples" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.examples')}
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.pricing')}
                </Link>
              </li>
              <li>
                <Link to="/pricing#api-pilot" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.apiDocs')}
                </Link>
              </li>
              <li>
                <Link to="/pricing#faq" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.helpCenter')}
                </Link>
              </li>
              <li>
                <Link to="/pricing#contact" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.techSupport')}
                </Link>
              </li>
            </ul>
          </div>

          {/* 法律与政策 */}
          <div>
            <h4 className="font-semibold text-lg mb-4">
              <Link to="/terms-of-service" className="hover:text-blue-400 transition-colors">{t('footer.legalTitle')}</Link>
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacy-policy" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.privacyPolicy')}
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.termsOfService')}
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.security')}
                </Link>
              </li>
              <li>
                <Link to="/pricing#scope" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.compliance')}
                </Link>
              </li>
            </ul>
          </div>

          {/* 联系我们 */}
          <div>
            <h4 className="font-semibold text-lg mb-4">
              <Link to="/pricing#contact" className="hover:text-blue-400 transition-colors">{t('footer.contactTitle')}</Link>
            </h4>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-white transition-colors">
                  {t('footer.about')}
                </Link>
              </li>
              <li>
                <a href="mailto:contact@oredact.com" className="text-gray-300 hover:text-white transition-colors">
                  contact@oredact.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* 底部版权信息 */}
        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <div className="text-gray-400 text-sm flex items-center flex-wrap gap-1">
            <span>{t('footer.copyright')}</span>
            <span>|</span>
            <span>豫ICP备2025149205号-1</span>
            <span>|</span>
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=41010502006601" rel="noreferrer" target="_blank" className="hover:text-white transition-colors inline-flex items-center gap-1">
              <img src="/beian.png" alt="公安备案" className="inline-block" style={{ width: '16px', height: '16px', verticalAlign: 'middle' }} />
              <span>豫公网安备41010502006601号</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
